var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("channel")]),_c('path',{attrs:{"d":"M12,5.25l6,4.5v9H14.25V13.5H9.75v5.25H6v-9Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }